import {Component, input} from '@angular/core';
import {NgStyle} from "@angular/common";


@Component({
    selector: 'placeholder',
    imports: [
        NgStyle
    ],
    templateUrl: './placeholder.component.html',
    standalone: true
})

export class PlaceholderComponent {

    readonly icolor = input.required<string>();

    constructor() {
    }
}
